import React, { useEffect, useState } from 'react'
import KnowMoreSection from '../Home/KnowMoreSection'
import { Box, Grid2, Typography } from '@mui/material'
import Heading from '../../shared/utils/Heading'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Page_Padding } from '../../shared/constants'
import CustomSelectBox from '../../shared/utils/CustomSelectBox'
import Apartment from './Apartment'
import PreSchool from './PreSchool'
import Individual from './Individual'
import useContactStore from '../../shared/store/contactStore'
const optionsList = [
    { label: "Apartment", value: "Apartment" },
    { label: "PreSchool", value: "PreSchool" },
    { label: "Individual", value: "Individual" },
];

const ApartmentOnboarding = () => {

    const [selectedOption, setSelectedOption] = useState(optionsList[0].value); // Default to first option
    const { resetContactPersons } = useContactStore();

    useEffect(() => {
        resetContactPersons();
    }, [selectedOption, resetContactPersons]);

    const renderSelectedComponent = () => {
        switch (selectedOption) {
            case "Apartment":
                return <Apartment />;
            case "PreSchool":
                return <PreSchool />;
            case "Individual":
                return <Individual />;
            default:
                return null;
        }
    };

    return (
        <Box className="body apartment_onboarding" px={Page_Padding}>
            <KnowMoreSection />
            <CustomDivider orientation='horizontal' />
            <Heading
                Heading="Get settled in smoothly with our step-by-step  On Boarding guide"
                SubHeading="Welcome to Your New Home! "
            />
            <Grid2 container spacing={2}>
                <Typography variant='body1' fontFamily={600}>How would you like to on-board yourself ? </Typography>
                <Grid2 container size={{ xs: 6, lg: 3 }}>
                    <CustomSelectBox
                        options={optionsList}
                        value={selectedOption}
                        onChange={setSelectedOption}
                    />
                </Grid2>
            </Grid2>
            <CustomDivider orientation='horizontal' sx={{ borderBottm: "1px solid #C7C7C7" }} />
            {renderSelectedComponent()}
        </Box >
    )
}

export default ApartmentOnboarding